import 'src/pages/userComponents/userStyle.scss';
import 'antd/dist/antd.css';

import { CloseCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { Col, Form } from 'antd';
import React, { useEffect, useState } from 'react';

import Input from 'src/pages/userComponents/text-field/index';
import SalesForceCheckbox from 'src/pages/userComponents/menus/Delivery-card page/salesForceCheckbox';
import TextComponent from '@sharedComponent/typography/TextComponent';
import { images } from 'src/assets/img/index.js';
let regEmail =
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// import '../userStyle.scss';

const AdditionalContacts = ({ index, hrNameProp, hrMobileProp, hrLandlineProp, hrEmailProp, removeContact, handleValueChange }) => {
	const [hrName, setHrName] = useState(hrNameProp);
	const [hrMobile, setHrMobile] = useState(hrMobileProp);
	const [hrLandline, setHrLandline] = useState(hrLandlineProp);
	const [hrEmail, setHrEmail] = useState(hrEmailProp);
	const [allow, setAllow] = useState(false);

	const [errorMsgList, setErrorMsgList] = useState({
		subHrNameerr: '',
		subHrMobileerr: '',
		subHrLandlineer: '',
		subHrEmailerr: '',
	});

	useEffect(() => {
		setHrName(hrNameProp);
		setHrMobile(hrMobileProp);
		setHrLandline(hrLandlineProp);
		setHrEmail(hrEmailProp);
	}, [hrNameProp, hrMobileProp, hrLandlineProp, hrEmailProp]);

	const onFinish = () => {
		if (hrName && hrMobile && hrEmail && allow) {
			// props && props.navigateDisabled(false);
		} else {
			// props && props.navigateDisabled(true);
		}
	};

	const validateMessages = (changeValue, allValue) => {
		if (allValue.subHrNumber && allValue.subHrNumber.replace(/[^0-9]/g, '')?.length !== 8) {
			setAllow(false);
		} else if (allValue.subHrLandline && allValue.subHrLandline.replace(/[^0-9]/g, '')?.length !== 8) {
			setAllow(false);
		} else if (allValue.subHrEmail && !regEmail.test(allValue.subHrEmail)) {
			setAllow(false);
		} else {
			setAllow(true);
		}
	};

	const validateForm = (e) => {
		if (e.target.name == 'subhrNumber') {
			if (hrMobile?.length > 8) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrMobileerr: 'Mobile Number must be within 8 digits' };
				});
			} else if (hrMobile?.length < 8) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrMobileerr: 'Mobile Number must be not  less than 8 digits' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrMobileerr: '' };
				});
			}
		}

		if (e.target.name == 'subHrLandline') {
			if (hrLandline?.length > 8 && hrLandline?.length !== 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrLandlineer: 'Landline Number must be within 8 digits' };
				});
			} else if (hrLandline?.length < 8 && hrLandline?.length !== 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrLandlineer: 'Landline Number must be not less than 8 digits' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrLandlineer: '' };
				});
			}
		}

		if (e.target.name == 'subHrEmail') {
			if (!regEmail.test(hrEmail)) {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrEmailerr: 'Email is not Valid' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, subHrEmailerr: '' };
				});
			}
		}
	};

	return (
		<>
			<div className="headercontainer" key={index}>
				<div className="close-container">
					{' '}
					<TextComponent className="medium">Additional Contact</TextComponent>
					<div onClick={() => removeContact(index)} style={{ cursor: 'pointer' }}>
						{' '}
						X{/* <CloseCircleOutlined /> */}
					</div>
				</div>
				<TextComponent className="text2" style={{ marginTop: '20px' }}>
					<p>Additional contact in your company in case we cannot reach your main contact.</p>
				</TextComponent>
			</div>
			<div className="hrcontact_container">
				<Form onFinish={onFinish} onValuesChange={validateMessages}>
					<Form.Item name="subHrName" initialValue={''}>
						<div className="global_input_Container">
							<Input
								name="subHrName"
								maxLength={100}
								type="text"
								onBlur={validateForm}
								labels={
									<span>
										Name <text style={{ color: 'red' }}>*</text>
									</span>
								}
								value={hrName}
								// onChange={(e) => setHrName(e.target.value.replace(/[^A-Za-z]/gi, ''))}
								onChange={(e) => handleValueChange(index, 'hrNameProp', e.target.value.replace(/[^A-Za-z]/gi, ''))}
							/>
							<div>
								<TextComponent className="errorText">{errorMsgList.subHrNameerr}</TextComponent>
							</div>
						</div>
					</Form.Item>
					<Form.Item name="subHrNumber">
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							{' '}
							<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
								<div style={{ width: '30%', display: 'flex', alignItems: 'center' }}>
									<div className="country_container">
										<img className="countryFlag" src={images.UAE} />
										<div className="countrycode" style={{ width: 'max-content', paddingRight: 20 }}>
											<TextComponent className="contact_no_text">+971 5</TextComponent>
										</div>
									</div>
								</div>
								<div className="contact_container" style={{ width: '-webkit-fill-available' }}>
									<div className="global_input_Container">
										<Input
											name="subhrNumber"
											maxLength={8}
											type="text"
											onBlur={validateForm}
											labels={
												<span>
													Mobile Number <text style={{ color: 'red' }}>*</text>
												</span>
											}
											style={{ width: '300px !important' }}
											value={hrMobile}
											onChange={(e) => handleValueChange(index, 'hrMobileProp', e.target.value.replace(/[^0-9]/g, ''))}
										/>
									</div>
								</div>
							</div>
							<div>
								<TextComponent className="errorText">{errorMsgList.subHrMobileerr}</TextComponent>
							</div>
						</div>
					</Form.Item>
					<Form.Item name="subHrLandline">
						<div className="global_input_Container">
							<Input
								maxLength={8}
								name="subHrLandline"
								type="text"
								onBlur={validateForm}
								labels={<span>Landline</span>}
								value={hrLandline}
								onChange={(e) => handleValueChange(index, 'hrLandlineProp', e.target.value.replace(/[^0-9]/g, ''))}
								// onChange={(e) => setHrLandline(e.target.value.replace(/[^0-9]/g, ''))}
							/>
							<div>
								<TextComponent className="errorText">{errorMsgList.subHrLandlineer}</TextComponent>
							</div>
						</div>
					</Form.Item>
					<Form.Item name="subHrEmail" initialValue={'some Name'}>
						<div className="global_input_Container">
							<Input
								maxLength={100}
								name="subHrEmail"
								type="text"
								onBlur={validateForm}
								labels={
									<span>
										Email ID <text style={{ color: 'red' }}>*</text>
									</span>
								}
								value={hrEmail}
								onChange={(e) => handleValueChange(index, 'hrEmailProp', e.target.value)}
								// onChange={(e) => setHrEmail(e.target.value)}
							/>
							<div>
								<TextComponent className="errorText">{errorMsgList.subHrEmailerr}</TextComponent>
							</div>
						</div>
					</Form.Item>
				</Form>
			</div>
		</>
	);
};
export default AdditionalContacts;
